import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Playlist } from '@reflact/interactionsuite';
import { ObjectId } from 'bson';
import { PlaylistService } from '../services/playlist.service';

@Injectable({
  providedIn: 'root'
})
export class PlaylistInfoResolver  {
  constructor(private playlistService: PlaylistService) { }
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Playlist | null> {
    if (route.params['playlistId'] == null) {
      return null;
    };
    const playlistId = new ObjectId(route.params['playlistId']);
    const result = await this.playlistService.getPlaylistInfo(playlistId);
    return result;
  }
}
